/**
 * Partner Reports API
 * Exports all partner report and field mapping API functions
 */

import * as reports from './reports';
import * as fieldMappings from './fieldMappings';

// Export individual functions for direct imports
export * from './reports';
export * from './fieldMappings';

// Export namespace object for components using partnerReportsApi
export const partnerReportsApi = {
  ...reports,
  ...fieldMappings,
};
